/**
 * Internal depedencies
 */
import * as actions from 'state/action-types';

export default (filters) => ({
	type: actions.SET_DASHBOARD_FILTERS,
	payload: { filters },
});
